<template>
    <div>
        <v-row no-gutters="" justify="center">
            <v-col cols="6" class="d-flex justify-center">
                Terms and conditions accepted on {{ props.termsAndConditionsDate }} for {{ props.termsAndConditionsCompany }}  
            </v-col>
        </v-row>
        <v-row no-gutters="" justify="center">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <RISETermsAndConditionsHTML></RISETermsAndConditionsHTML>
                <!-- <p>
                <div class="text-h4">
                    Dell Technologies RISE Incentive Program for Authorized Partners - Terms and Conditions
                </div>
                </p>
                <p>
                    Dell Technologies RISE Incentive Program for Authorized Partners - Terms and Conditions. (“Program
                    Terms”)
                    are supplemental and subject to the Dell Technologies Partner Program Agreement, and together with
                    any Dell
                    Technologies Partner Program Incentive Terms and Conditions (“Incentive Terms”) constitute the
                    entire
                    agreement (“Agreement”) between Dell Technologies and Partner with respect to the Dell Technologies
                    RISE
                    Program (“RISE Program” or the “Program”).
                </p>
                <p>
                    This Agreement supersedes any and all prior agreements and understandings regarding this Program. By
                    accepting these Program Terms, or by participating in the Program, you agree to be bound by all
                    terms,
                    conditions, and restrictions contained in the Agreement.
                </p>
                <p>
                    The individual accepting these Program Terms on behalf of Partner acknowledges he has full authority
                    to
                    represent and act on behalf of the Partner. Please print a copy of these Program Terms for your
                    records.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">DEFINITIONS</div>
                </p>
                <p>
                    For the purposes of these Program Terms, the following definitions apply:
                </p>
                <p>
                    “Campaign Activity” shall mean fixed term period during which Eligible Products can be redeemed
                    against
                    Reward;
                </p>
                <p>
                    “Campaign Activity Rules” shall mean rules provided by Dell Technologies which determine Eligible
                    Products
                    and the applicable Reward;
                </p>
                <p>
                    “Data Protection Law” shall mean the Regulation (EU) 2016/679 on the protection of natural persons
                    with
                    regard to the processing of personal data and on the free movement of such data (General Data
                    Protection
                    Regulation or “GDPR”) and any amendments, revisions, re-enactments or consolidations thereof,
                    together with
                    any other applicable data protection legislation;
                </p>
                <p>
                    “Distributor” shall mean a Dell Technologies Authorized Distributor tiered partner of the Dell
                    Technologies
                    Partner Program awarded a ‘distributor’ partner track in the Dell Technologies Partner Program,
                    which holds
                    a valid Dell Technologies Distribution Agreement, is signed up to RISE Program and included in the
                    list of
                    authorized Distributor is available on the Website.
                </p>
                <p>
                    “Dell Technologies” refers to the business units previously referred to as “Dell” and “Dell EMC” and
                    excludes SecureWorks and Virtustream business units.
                </p>
                <p>
                    “E-vouchers” shall mean Dell Technologies e-voucher credit against a future purchase of Dell
                    Technologies
                    products;
                </p>
                <p>
                    “Effective Date” shall mean the date Partner has accepted these Program Terms:
                </p>
                <p>
                    “Eligible Products” shall mean the list of stock and sell or back-to-back Eligible Products defined
                    in
                    Campaign Activity Rules;
                </p>
                <p>
                    “EMEA” shall mean all countries in Europe, Middle East and Africa;
                </p>
                <p>
                    "Monetary Incentive" shall mean the incentive payable, and funded by Dell Technologies, in US $
                    (USD) or its
                    equivalent in local currency (by applying the Dell Technologies internal rate) on the date of
                    payment from
                    the Distributor, or a third party authorized by Dell Technologies to transact between Dell
                    Technologies and
                    the Distributor, to eligible Partners inclusive of any applicable VAT and any other taxes, which is
                    paid or
                    credited by the Distributor, or a third party authorized by Dell Technologies to transact between
                    Dell
                    Technologies and the Distributor, to the eligible Partner(s) in accordance with the instructions of
                    Dell
                    Technologies for achievement of Qualifying Threshold within the relevant RISE Program Period (as
                    communicated to Partners via email as applicable);
                </p>
                <p>
                    “Partner” shall mean a Dell Technologies Partner Program Authorized tiered partner of the Dell
                    Technologies
                    Partner Program purchasing the Eligible Products from the Distributor in EMEA locally in the country
                    where
                    Distributor is Authorized by Dell Technologies to conduct the business and sell the Eligible
                    Products, has a
                    local registered office and legal presence in that country, signed up to the RISE Program and
                    complies with
                    eligibility requirements set out in Section 2 of these Program Terms;
                </p>
                <p>
                    “Personal Data” shall have the meaning in the General Data Protection Regulation (EU) 2016/679;
                </p>
                <p>
                    “Qualifying Threshold” shall mean the minimum threshold of Eligible Products by revenue or units,
                    which must
                    be purchased by the Partner from the Distributor in the same EMEA country where Distributor is
                    contracted to
                    conduct business and sell these Eligible Products to the Partner. Qualifying Threshold shall be
                    determined
                    using the shipped amount or the booked order amount for Eligible Products as applicable. Qualifying
                    Threshold excludes all taxes, freight/delivery and handling charges associated with, and all returns
                    and
                    cancellations of such purchases, as well as sales of refurbished products (collectively,
                    “Exclusions”). Any
                    such Exclusions, if not excluded from Qualifying Threshold made in a particular Incentive Period ,
                    may be
                    excluded from Qualifying Threshold in a later Incentive Period ;
                </p>
                <p>
                    “Incentive Period ” shall mean Dell Technologies fiscal quarter, which typically ends in April,
                    July,
                    October, and January;
                </p>
                <p>
                    “Reward” shall means incentives earned in compliance with these Program Terms and under relevant
                    Dell
                    Technologies Campaign Activity Rules as determined by Dell Technologies.
                </p>
                <p>
                    The Reward can only be redeemed in a form of / as
                </p>
                <p>
                    E-Voucher
                </p>
                <p>
                    If payable Reward is below $750 (USD) per Incentive Period
                </p>
                <p>
                    Monetary Incentive via pass-through credit notes
                </p>
                <p>
                    If payable Reward is equal or above $750 (USD) per Incentive Period
                </p>
                <p>
                    No reimbursement will be made in any other form or by any other means of payment;
                </p>
                <p>
                    “Website” shall mean www.dellpartnerincentives.com.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">PROGRAM PERIOD</div>
                </p>
                <p>
                    The RISE Program will begin on the Effective Date, is entered into between the parties for the
                    period of the
                    current Incentive Period , and will auto-renew every Incentive Period under these Program Terms,
                    updated
                    Campaign Activity Rules and Qualifying Threshold as communicated via Website in the respective
                    Incentive
                    Period , unless it is earlier terminated by Dell Technologies as permitted by these Program Terms.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">ELIGIBLE PARTICIPANTS</div>
                </p>
                <p>
                    A Partner is eligible to enrol in the RISE Program if Partner meets the following cumulative
                    criteria:
                    <br>
                <ol type="a">
                    <li>
                        Partner has accepted the Dell Technologies Partner Program Agreement and participates in the
                        Dell
                        Technologies Partners Program as an ‘Authorized Partner’ (“Partner Tier”). Partner Tier will be
                        determined by Dell Technologies and be used for the purposes of determining program eligibility
                        and
                        calculating incentives. Partner shall remain in the assigned Partner Tier “Authorized” until the
                        end of
                        each Incentive Period to be eligible to receive Reward for each qualifying Incentive Period ;
                    </li>
                    <li>
                        Partner has accepted these Program Terms on the Website;
                    </li>
                    <li>
                        Partner is buying Eligible Products from Distributor, and
                    </li>
                    <li>
                        Partner has a registered office and legal presence in the country where Distributor is
                        contracted with
                        Dell Technologies to conduct business.
                    </li>
                </ol>
                </p>
                <p>
                    The RISE Program is intended to reward Partners who comply with the Program Terms and Campaign Rules
                    which are focused on purchase of Eligible Products from Distributors.
                </p>
                <p>
                    Whenever Partner is located in EMEA, he must sign up to Programs Terms in each country where he has
                    a registered office and will participate to the RISE Program in each of these countries separately.
                </p>
                <p>
                    Depending on the Qualifying Threshold made by Partner on Incentive Period basis, Partner may be
                    eligible to benefit from distinct & non-cumulative Rewards. Partner will be required to register on
                    the applicable Website and accept these Program Terms.
                </p>
                <br>
                <br>

                <p>
                <div class="text-h5">PROGRAM OPERATIONS</div>
                </p>
                <p>
                    Rise Rewards payment process applicable for Rewards payable below $750 (USD) per Incentive Period :
                </p>
                <p>
                <ol type="a">
                    <li>
                        Partner will be able to view its cumulative Rewards on the Website.
                    </li>
                    <li>
                        Partner can redeem its Rewards directly on the Website. Partner will be informed via the Website
                        when the Partner can start to redeem his Rewards with a chosen Distributor in a format of an
                        E-voucher (“Redemption Period”). The Partner shall use the E-voucher no later than on the expiry
                        date stated on the E-Voucher, otherwise it expires.
                    </li>
                    <li>
                        Rewards consist of E-Vouchers, or pass-through credit notes (as described in the applicable
                        Campaign Activity Rules on the Website). To redeem the Rewards for an E-voucher, Partner will
                        request on the Website the amount of the E-voucher to be redeemed and will mention with which
                        Distributor it will be used with. The maximum E-Vouchers’ value that a Partner can obtain per
                        Incentive Period is limited to 749.99$ (USD) per Incentive Period . The Partner acknowledges and
                        accepts that the Rewards will not be pushed to the following Incentive Period . Once completed,
                        the Partner will receive a Dell Technologies code (or up to 5). Whenever the Partner will want
                        to apply this E-voucher to his future Dell Technologies products order, he will communicate this
                        Dell Technologies code to a Distributor. The Distributor, after having checked this code is
                        still valid, will deduct the value of the Dell Technologies E-voucher against Partner order
                        amount. The full balance of the Dell Technologies E-voucher has to be redeemed in one
                        transaction. There is no cash refund.
                    </li>
                    <li>
                        When e-voucher is redeemed, it is sent to the Partner email address held on the Website. The
                        actual Partner email address can be viewed under ‘My Profile’, and can changed upon Partner’s
                        request (by contacting Website customer service). Dell Technologies will not be held responsible
                        if the address is incorrect.
                    </li>
                    <li>
                        The E-Vouchers can be redeemed by ordering to Distributors offline and/or online (Distributors
                        choice). Only one Dell Technologies E-voucher can be used per order to the Distributor. Order
                        value to the Distributor has to be strictly superior to the value of the E-voucher when using it
                        on that order.
                    </li>
                    <li>
                        E-Vouchers may not be exchanged for cash nor refunded.
                    </li>
                    <li>
                        E-Vouchers may not be transferred or sold.
                    </li>
                    <li>
                        Dell Technologies E-voucher may only be redeemed against products purchased in the same currency
                        as the reward E-voucher.
                    </li>
                    <li>
                        E-Vouchers and Dell Technologies codes expire on the date stated on the e-voucher.
                    </li>
                    <li>
                        Dell Technologies is not responsible if a Dell Technologies E-voucher or Dell Technologies code
                        is lost, stolen, destroyed or used without permission and no replacement will be provided in
                        these circumstances.
                    </li>
                    <li>
                        E-voucher are unique and for one single use only. If Dell Technologies finds out that Partner is
                        trying to utilize E-voucher multiple times, Dell Technologies will exclude partners of the Dell
                        Technologies’ Partner programs.
                    </li>
                </ol>
                </p>
                <p>
                    RISE Rewards payment process applicable for Rewards payable equal to or above $750 (USD) per
                    Incentive Period :
                </p>
                <p>
                <ol type="a">
                    <li>
                        The Partner will be provided with a unique Dell Technologies Partner ID which he agrees to
                        provide to its relevant Distributors.
                    </li>
                    <li>
                        The Distributors will provide to Dell Technologies regular reports of the Dell Technologies
                        products and services that Partner has bought using this unique Dell Technologies Partner ID.
                    </li>
                    <li>
                        Monetary Incentive amounts will be calculated according to such information provided to Dell
                        Technologies by participating Distributors. Dell Technologies will calculate the Partner
                        Monetary Incentive according to the sales data reported by Distributor to Dell Technologies or a
                        third party acting on Dell Technologies’ behalf (e.g. E2open/Zyme etc.). To the extent that
                        there is a shortfall in the calculation of the Monetary Incentive, Distributor will compensate
                        the Partners for any missing or incorrect Monetary Incentive amount incurred due to missing or
                        incorrect sales data reported by Distributor to Dell Technologies or a third party acting on
                        Dell Technologies’ behalf (e.g. E2open/Zyme etc.) with no further recourse to Dell Technologies.
                    </li>
                    <li>
                        Special deal(s) or deals with special pricing (for example, units purchased for back to back
                        deals (B2B) or similar programs where special deal prices apply) are excluded from the
                        calculation of the Incentive Period Monetary Incentive calculation. However, for the avoidance
                        of doubt, whilst the Partner may have been paid the Monetary Incentive, for the Qualifying
                        Incentive Period , on units without service tags, when Distributor subsequently provides valid
                        service tags for the units with missing service tags and these units prove to be part of special
                        deal(s) or deals with special pricing, then Dell Technologies:

                        <ol type="a" style="list-style-position: inside;">
                            <li>
                                Reserves the right to retrospectively revise attainment units of Partner on Qualifying
                                Threshold; and
                            </li>
                            <li>
                                Debits the excessive payment made to Partner via the Distributor corresponding to the
                                revised Monetary Incentive calculation, in subsequent Incentive Period/s.
                            </li>

                        </ol>
                    </li>
                    <li>
                        The calculation of the Monetary Incentive is restricted to the purchase of Eligible Products
                        only, which are outlined in the Campaign Rules. Dell Technologies may unilaterally, at any time,
                        alter or further restrict the RISE Program to specified products only, provided that any
                        variation will not apply retrospectively.
                    </li>
                    <li>
                        Incentive Period payments/credits will be made to eligible Partners either via the participating
                        Distributor from whom the Eligible Products have been purchased or via a third party. If the
                        participating Partners purchase Dell Technologies Eligible Products from more than one
                        Distributor, then payments/credits may be received from more than one Distributor or third party
                        authorized by Dell Technologies to transact between Dell Technologies and the Distributor. The
                        Partners agrees to Dell Technologies forwarding the details and information of the Partners
                        about the Monetary Incentive to the third-party Dell Technologies chooses to pay or credit the
                        Monetary Incentive to the Partners.
                    </li>
                    <li>
                        Where the Partners obtains the Monetary Incentive from Dell Technologies through a Distributor
                        or third party authorized by Dell Technologies to transact between Dell Technologies and the
                        Distributor, the Partners may only be entitled to a payment/credit if they enter into an
                        agreement with the Distributor or third party in relation to the Monetary Incentive (where
                        applicable). The participating Distributor may credit the Partner’s account or set-off the
                        amount against any monies due to the Distributor from which the Partner has purchased the
                        Eligible Products only. Subject to such agreement between the Distributor and the Partner and
                        any local accounting rules, the Partner can expect to receive a credit/payment from their
                        Distributor within 90 days after the end of the applicable Incentive Period. The Partner may not
                        set off any potential Monetary Incentive payments against their Distributor accounts, as a
                        result of the RISE Program, without prior agreement with the participating Distributor. The
                        Monetary Incentive from Dell Technologies will be passed through the participating Distributor
                        to participating Authorized resellers for the Dell Technologies Eligible Products only, and not
                        for any other vendor products, purchased by the participating Partner.
                    </li>
                </ol>
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">ACCESSING THE WEBSITE</div>
                </p>
                <p>
                    Partner agrees that for all electronic communications, an identification code (“Login ID”) contained
                    in an electronic document is sufficient to verify the sender’s identity and the document’s
                    authenticity. Partner is responsible for maintaining the confidentiality of his Login ID and
                    password and is fully responsible for all activities that occur under their program Login ID.
                    Partner agrees to immediately notify Dell Technologies of any unauthorized use of their Login ID or
                    account or any other breach of security.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">TAXES</div>
                </p>
                <p>
                    All applicable taxes (including, but not limited to, Value Added Tax and Withholding Taxes) on
                    Rewards are the sole responsibility of Partner. In certain circumstances, Dell Technologies may
                    elect to pay applicable taxes on the amount of Rewards. Partner may be required to provide relevant
                    tax information to Dell Technologies for tax reporting purposes. Failure to provide requested tax
                    information, where applicable, to Dell Technologies within thirty (30) days after Partner’s
                    enrolment in RISE program may result in forfeiture by Partner of the Rewards.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">DATA PROTECTION</div>
                </p>
                <p>
                    Notwithstanding any separate confidentiality agreement Partner may have with Dell Technologies and
                    to the extent permitted by the applicable law, Partner authorizes and agrees that information
                    regarding Partner’s business with Dell Technologies and any information, including Personal
                    Information Partner provides to Dell Technologies in connection with the Program may be accessed and
                    used by Dell Technologies and Dell Technologies Affiliates and their employees and contractors for
                    sales and marketing purpose and for any purpose related to the Program or the relationship between
                    you and Dell Technologies (collectively, “Purpose”) and may be disclosed to relevant Distributors or
                    resellers, governing body, or your customers or end users for the Purpose or to fulfil Dell
                    Technologies obligations to the Partner and/or Partner’s customers or end-users. Partner agrees that
                    also the Distributor may provide any personal information to Dell Technologies. The Partner is
                    responsible to ensure that any Personal Data have been collected solely for the Purpose and is
                    shared with Dell Technologies in accordance with the confidentiality and data protection provisions
                    of the Dell Technologies Partner Program Agreement, including its Data Processing Schedule and Dell
                    Technologies privacy policy, which can be consulted in the following link:
                    http://www.dell.com/learn/us/en/uscorp1/policies-privacy-country-specific-privacypolicy; and after
                    having obtained prior data subject’s consent.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">LIMITATION OF LIABILITY</div>
                </p>
                <p>
                    PARTNER ACKNOWLEDGES THAT HIS PARTICIPATION IN RISE IS STRICTLY VOLUNTARY AND IS NOT REQUIRED BY
                    DELL TECHNOLOGIES AS A CONDITION FOR ANY OTHER PROGRAM FROM DELL TECHNOLOGIES OR ANY OTHER BUSINESS
                    RELATIONSHIP WITH DELL TECHNOLOGIES. PARTNER AGREES THAT HIS SOLE AND EXCLUSIVE REMEDY, IN LAW, IN
                    EQUITY, OR OTHERWISE, WITH RESPECT TO DLP AND/OR ANY BREACH OF THE PROGRAM TERMS IS WITHDRAWAL FROM
                    PARTICIPATION IN DLP.
                </p>
                <br>
                <br>

                <p>
                <div class="text-h5">MODIFICATION, TERMINATION AND SURVIVAL</div>
                </p>
                <p>
                <ol type="a">
                    <li>
                        Modification: Dell Technologies reserves the right to modify RISE Program (including eligibility
                        requirements, Rewards, and Program Terms) at its discretion. If any modification is unacceptable
                        to Partner, his sole recourse is to terminate his participation in RISE Program. If he continues
                        to participate in RISE, it will constitute his binding acceptance of the modification. Partner
                        may not assign the Program Terms, or any Rewards due under RISE Program, to any third party
                        without the express written consent of Dell Technologies.
                    </li>
                    <li>
                        Partner may withdraw from RISE Program without penalty at any time by notifying Dell
                        Technologies in writing.
                    </li>
                    <li>
                        Dell Technologies may remove Partner from RISE Program at any time without notice, if (a) he
                        does not comply with the Program Terms, (b) he no longer meets the eligibility requirements
                        mentioned in article 2.
                    </li>
                    <li>
                        Dell Technologies may terminate RISE Program at any time for its own convenience, by giving
                        Partner written notice of its intent to terminate. All provisions which by their nature are
                        intended to survive the termination of the Program Terms shall survive.
                    </li>
                </ol>
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">INDEPENDENT CONTRACTORS</div>
                </p>
                <p>
                    Dell Technologies and Partner are independent contractors. Neither party will state, imply, nor
                    knowingly permit anyone to infer that any other relationship exists between the parties
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">DISPUTES</div>
                </p>
                <p>
                    In the event of a dispute as regards application of these Program Terms, you are welcome to request
                    an email or phone dialogue or meeting with support@dellpartnerincentives.com to discuss the issue
                    and to provide evidence to support the dispute, within a 4 week period following the Incentive
                    Period during which the event, cause of the dispute, has arisen. If Partner does not file a dispute
                    with Dell Technologies within that period then Dell Technologies is not liable or obligated to make,
                    and Partner forfeits receipt of, any and all disputed Rewards under the RISE Program.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">SUBCONTRACTING</div>
                </p>
                <p>
                    Dell Technologies may subcontract its obligations under the Program terms but shall remain liable
                    and responsible to Partner for such obligations.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">PROGRAME ADMINISTRATOR</div>
                </p>
                <p>
                    The administration and calculation of Rewards may be conducted by a 3rd party vendor acting as a
                    program administrator on behalf of Dell Technologies (“Program Administrator”).
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">BUSINESS CONDUCT AND COMPLIANCE WITH ANTI-CORRUPTION LAWS</div>
                </p>
                <p>
                    Partner represents and warrants that Partner understands and agrees to comply with its obligations
                    under the Dell Technologies Partner Code of Conduct, including compliance with the Anti-Corruption
                    Laws, as defined therein, in connection with this Agreement. Partner will not, in connection with
                    this Agreement, take or allow any third party to take, any action or engage in any practice that
                    would violate the Anti-Corruption Laws.
                </p>
                <p>
                    Partner represents and warrants that: (i) neither Partner nor any of Partner’s directors or officers
                    or employees, who have decision-making authority with respect to this Agreement, have been convicted
                    of any offense involving bribery, corruption, fraud or dishonesty, or to the best of Partner’s
                    knowledge, have been or are the subject of any investigation, inquiry or enforcement proceeding by
                    any governmental, administrative or regulatory body regarding any offense or alleged offense under
                    the Anti-Corruption Laws and (ii) neither Partner nor any of Partner’s directors or officers or
                    employees, who have decision-making authority with respect to this Agreement, are government
                    officials. Dell Technologies may immediately terminate this Agreement or suspend its performance
                    hereunder if Dell Technologies has reason to believe that Partner has breached this Section 15 or
                    the Dell Technologies Partner Code of Conduct.
                </p>
                <br>
                <br>
                <p>
                <div class="text-h5">MISCELLANEOUS</div>
                </p>
                <p>
                    THE PARTIES AGREE THAT THIS AGREEMENT, OR ANY CLAIM, DISPUTE, OR CONTROVERSY (WHETHER IN CONTRACT,
                    TORT, OR OTHERWISE, WHETHER PREEXISTING, PRESENT OR FUTURE, AND INCLUDING STATUTORY, COMMON LAW, AND
                    EQUITABLE CLAIMS) BETWEEN PARTNER AND DELL TECHNOLOGIES BASED UPON, ARISING FROM, OR RELATING TO
                    THIS AGREEMENT, ITS INTERPRETATION, OR THE BREACH, TERMINATION OR VALIDITY THEREOF, THE
                    RELATIONSHIPS THAT RESULT FROM THIS AGREEMENT, DELL TECHNOLOGIES’ ADVERTISING, OR ANY RELATED
                    PURCHASE SHALL BE SUBJECT TO AND GOVERNED EXCLUSIVELY BY THE APPLICABLE LAW (WITHOUT REGARD TO ITS
                    CONFLICTS OF LAWS RULES) OF THE JURISDICTION WHERE THE DELL TECHNOLOGIES ENTITY WITH WHICH THE
                    PARTNER TRANSACTS BUSINESS, IS LOCATED AND REGISTERED.
                </p>
                <br>
                <br> -->
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>

    </div>
</template>

<script setup>
import RISETermsAndConditionsHTML from '@/components/RISETermsAndConditionsHTML.vue'

const props = defineProps({
  termsAndConditionsDate: { type: String, default: ''},
  termsAndConditionsCompany: { type: String, default: ''}
})

</script>